import { IOccupierService, IOccupierServiceRes, IDropdownResponse } from './../models';
import axios, { AxiosResponse } from 'axios';

import { authFetch } from './fetch';

const baseUrl = '/api/Admin/OccupierServices';

export const IOccupierServiceAPI = {
  async getAll(filters?: {
    page?: number;
    perPage?: number;
    sortBy?: string;
    sortDirection?: string;
  }): Promise<IOccupierServiceRes> {
    try {
      const response: AxiosResponse<IOccupierServiceRes> = await authFetch.get(baseUrl, filters);

      if (!(response.status >= 200 && response.status < 300)) {
        throw Error(response.statusText);
      }

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw Error(error?.response?.data);
      }
      throw error;
    }
  },

  async getOccupierServices(productType: string) {
          try {
              const result = await authFetch.get(`${baseUrl}/${productType}`);
              return result;
          } catch (error) {
              return Promise.reject(error);
          }
      },

  async upsert(upsertData: IOccupierService): Promise<IOccupierService> {
    try {
      const payload = { occupierService: upsertData };
      const response: AxiosResponse<IOccupierService> = await authFetch.put(baseUrl, payload);

      if (!(response.status >= 200 && response.status < 300)) {
        throw Error(response.statusText);
      }

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw Error(error?.response?.data);
      }
      throw error;
    }
  },

    async delete(occupierServiceId: number): Promise<void> {

    try {
      
      const response = await authFetch.delete(`${baseUrl}/${occupierServiceId}`);

      if (!(response.status >= 200 && response.status < 300)) {
        throw Error(response.statusText);
      }

        return;

    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw Error(error?.response?.data?.Detail);
      }
      throw error;
      }

  },
};

export const getOccupierServiceProductTypes = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await authFetch.get(`${baseUrl}/lookup/occupierservice-producttypes`);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};